module.exports = __webpack_public_path__ + "img/qrbox.a8fbf84b.webp";